// 消息提示工具（替代 Element Plus 的 ElMessage）

/**
 * 显示成功消息
 * @param {string} message 消息内容
 * @param {number} duration 显示时长（毫秒）
 */
export const showSuccess = (message, duration = 2000) => {
  // 已禁用弹出提示
  console.log('Success:', message);
}

/**
 * 显示错误消息
 * @param {string} message 消息内容
 * @param {number} duration 显示时长（毫秒）
 */
export const showError = (message, duration = 2000) => {
  // 已禁用弹出提示
  console.log('Error:', message);
}

/**
 * 显示警告消息
 * @param {string} message 消息内容
 * @param {number} duration 显示时长（毫秒）
 */
export const showWarning = (message, duration = 2000) => {
  // 已禁用弹出提示
  console.log('Warning:', message);
}

/**
 * 显示普通消息
 * @param {string} message 消息内容
 * @param {number} duration 显示时长（毫秒）
 */
export const showInfo = (message, duration = 2000) => {
  // 已禁用弹出提示
  console.log('Info:', message);
}

/**
 * 显示加载中
 * @param {string} message 消息内容
 * @param {boolean} mask 是否显示透明蒙层
 */
export const showLoading = (message = '加载中...', mask = true) => {
  // 已禁用加载提示
  console.log('Loading:', message);
}

/**
 * 隐藏加载中
 */
export const hideLoading = () => {
  // 已禁用加载提示
  console.log('Hide loading');
}

/**
 * 显示确认对话框
 * @param {string} content 内容
 * @param {string} title 标题
 * @returns {Promise<boolean>} 用户选择结果
 */
export const showConfirm = (content, title = '提示') => {
  // 已禁用确认对话框，默认返回true
  console.log('Confirm:', title, content);
  return Promise.resolve(true);
}

/**
 * 显示操作菜单
 * @param {Array<string>} items 菜单项数组
 * @returns {Promise<number>} 选中的索引，取消返回-1
 */
export const showActionSheet = (items) => {
  // 已禁用操作菜单，默认返回第一项
  console.log('ActionSheet:', items);
  return Promise.resolve(0);
}

// ElMessage 兼容层
export const ElMessage = {
  success: showSuccess,
  error: showError,
  warning: showWarning,
  info: showInfo
}

// 默认导出
export default {
  success: showSuccess,
  error: showError,
  warning: showWarning,
  info: showInfo,
  loading: showLoading,
  hideLoading,
  confirm: showConfirm,
  actionSheet: showActionSheet,
  ElMessage
}
